export const config = {
    apiUrl: 'http://30.29.60.87:3010'
  };